"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ys-fixed-bottom-actions"
  }, [_c("div", {
    staticClass: "statistic"
  }, [_vm._v(" 已选择" + _vm._s(_vm.data.length) + " "), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.handleClear
    }
  }, [_vm._v("清空所选内容")])], 1), _c("div", {
    staticClass: "actions"
  }, [_vm._t("actions")], 2)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;